<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">呼叫统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
            <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="按日期"></a-tab-pane>
                <a-tab-pane key="2" tab="按部门"></a-tab-pane>
                <a-tab-pane key="3" tab="按员工"></a-tab-pane>
            </a-tabs>

            <div class="top-search">
                <a-row type="flex">
                    <a-col><label for="">通话日期：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" placeholder="今天" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">部门/员工：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话类型：</label></a-col>
                    <a-col>
                        <a-select default-value="1" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                呼入
                            </a-select-option>
                            <a-select-option value="2">
                                呼出
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话方式：</label></a-col>
                    <a-col>
                        <a-select placeholder="全部" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                4G云网通
                            </a-select-option>
                            <a-select-option value="2">
                                云呼叫
                            </a-select-option>
                            <a-select-option value="2">
                                多卡全网通
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话时长：</label></a-col>
                    <a-col>
                        <a-select placeholder="全部" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                4G云网通
                            </a-select-option>
                            <a-select-option value="2">
                                云呼叫
                            </a-select-option>
                            <a-select-option value="2">
                                多卡全网通
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </div>

            <div class="tj-charts">

                <div class="chart-content">
                    <div id="weightChart" style="width: 100%;height:394px;"></div>
                </div>
            </div>

            
            <div class="table-content">
                <div class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>接听率：0%</div>
                    <div>通话人数：0</div>
                    <div>通话次数：0</div>
                    <div>接听次数：0</div>
                    <div>累计通话时长：0</div>
                    <div>平均通话时长：0</div>
                </div>

                <a-table :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '联系时间',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '通话人数',
    dataIndex: 'age',
    key: 'age',
    width: 80,
  },
  {
    title: '通话时长',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true,
  },
  {
    title: '呼出次数',
    dataIndex: 'address',
    key: 'address 2',
    ellipsis: true,
  },
  {
    title: '接听次数',
    dataIndex: 'address',
    key: 'address 3',
    ellipsis: true,
  },
  {
    title: '接听率',
    dataIndex: 'address',
    key: 'address 4',
    ellipsis: true,
  },
  {
    title: '平均通话时长',
    dataIndex: 'time',
    key: 'time',
    ellipsis: true,
  }
];

const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];

export default {
    data(){
        return{
            data,
            columns,
        }
    },
    mounted(){
        this.drawLine()
    },
        methods:{
        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                xAxis: {
                    type: 'category',
                    data: ['2:00', '4:00', '6:00', '8:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'],
                    boundaryGap: false,
                },
                yAxis: {
                    name: '呼出/接听次数',
                    type: 'value'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#fff',
                            color: '#333'
                        },
                    }
                },
                grid: {  
                    left: '5%',  
                    right: '4%', 
                    top:'15%', 
                    bottom: '10%',  
                    containLabel: true  
                },  
                series: [{
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true
                }]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/achievement.vue